import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {showWithdrawalModal} from "../../../actions/shippingPage";

export const Summary = ({data, validateShippingStepUrl}) => {
  const dispatch = useDispatch();
  const {shippingMethodsSelected, loading, shippingAddressesLoading, mustSelectWithdrawalAddress} = useSelector(
    state => ({
      shippingMethodsSelected: Object.entries(state.shippingReducer.payload.shippingMethodSelected || []),
      loading: state.shippingReducer.loading,
      shippingAddressesLoading: state.shippingReducer.shippingAddressesLoading,
      mustSelectWithdrawalAddress: state.shippingReducer.mustSelectWithdrawalAddress || [],
    })
  );
  const inputs = [];
  for (const [itemId, shippingMethod] of shippingMethodsSelected) {
    if (shippingMethod !== null) {
      inputs.push(<input key={itemId} type="hidden" name={`shipping_method_selected[${itemId}]`}
                         value={shippingMethod.id}/>);
    }
  }

  const displayModal = () => dispatch(showWithdrawalModal());

  const mustSelectWithdrawalAddressMessages = [];
  for (const [type, missing] of Object.entries(mustSelectWithdrawalAddress)) {
    if (missing) {
      mustSelectWithdrawalAddressMessages.push(<li key={type}><a className="text-danger" onClick={displayModal}
                                                                 href="#">
        {window.trans(`front.order.checkout.shipping_step.shipping_method.${type}.select`)}</a></li>);
    }
  }

  let shippingContent = <></>;
  if (loading) {
    shippingContent = <div className="loader-container">
      <div className="loader"/>
    </div>;
  } else {
    shippingContent = <>
      <div className="line">
        <p
          className="font-weight-bold mb-2">{window.trans('front.order.checkout.shipping_step.summary.total_shipping')}</p>
        <p className="font-weight-bold">{data.totalShipping}</p>
      </div>
      <ul className="card-summary-list">
        {data.totalShippingByLabel !== undefined
        && Object
          .entries(data.totalShippingByLabel)
          .sort(([label1,], [label2,]) => label1.toLowerCase() < label2.toLowerCase() ? -1 : 0)
          .map((totalShipping, index) => {
            const [label, priceFormatted] = Object.values(totalShipping);
            // @ts-ignore
            return <li className="line" key={index}>
              <div className="cart-summary-list-shipping__label">
                <small
                  className="text-muted">{window.trans('front.order.checkout.shipping_step.summary.shipping_prefix')}{label}</small>
              </div>
              <div
                data-free-text="{{ window.trans('front.order.checkout.shipping_step.index.free_delivery') }}">
                <small className="text-muted">
                  {priceFormatted !== null ? priceFormatted : window.trans('front.order.checkout.shipping_step.fee.included')}
                </small>
              </div>
            </li>
          })}
      </ul>
    </>;
  }

  return (
    <>
      <div className="bootstrap card">
        <div className="total-table compact">
          <div className="card-summary-title">
            <h3
              className="title-medium text-orange card-summary-title__title">{window.trans('front.order.checkout.shipping_step.summary.title')}</h3>
            <div className="card-summary-title__separator"/>
          </div>
          <div>
            <div className="line">
              <p
                className="font-weight-bold mb-2">{window.trans('front.order.checkout.shipping_step.summary.total')}</p>
              <p className="font-weight-bold">{data.totalItemInclExtraTaxes}</p>
            </div>
            {parseInt(data.totalRpdTax) > 0 &&
            <ul className="card-summary-list">
              <li className="line">
                <p className="mb-2">
                  <small
                    className="text-muted">{window.trans('front.order.checkout.shipping_step.summary.total_rpd_included')}</small>
                </p>
                <p>
                  <small className="text-muted">{data.totalRpdTax}</small>
                </p>
              </li>
            </ul>
            }
            {data.totalVoucherReduction !== undefined && parseInt(data.totalVoucherReduction) != 0 &&
            <div className="line">
              <p
                className="font-weight-bold mb-2 text-danger">{window.trans('front.order.checkout.shipping_step.summary.total_voucher')}</p>
              <p className="font-weight-bold text-danger">{data.totalVoucherReduction}</p>
            </div>
            }
            {shippingContent}
            <hr className="mb-2 mt-2"/>
            <div className="line">
              <p
                className="font-weight-bold mb-2">{window.trans('front.order.checkout.shipping_step.summary.total_ht')}</p>
              <p className="font-weight-bold">{!loading && data.grandTotalHTForCustomer}</p>
            </div>
            <div className="line">
              <p
                className="font-weight-bold mb-2">{window.trans('front.order.checkout.shipping_step.summary.total_ttc')}</p>
              <p className="font-weight-bold">{!loading && data.grandTotalForCustomer}</p>
            </div>
            <div className="line">
              <p className="mb-2">
                <small
                  className="text-muted">{window.trans('front.order.checkout.shipping_step.summary.total_vat_included')}</small>
              </p>
              <p>
                <small className="text-muted">{!loading && data.totalVat}</small>
              </p>
            </div>
          </div>
        </div>
        <div className="text-center">
          <form className="form" action={validateShippingStepUrl} id="next-step-shipping-method" method="POST">
            {inputs}
            <input type="submit" name="next-step"
                   value={window.trans('front.order.checkout.shipping_step.index.link_payment')}
                   className="submit btn btn-s btn-block"
                   disabled={
                     loading
                     || shippingAddressesLoading
                     || data.totalHt === 0
                     || Object.values(mustSelectWithdrawalAddress).filter(missingAddress => missingAddress === true).length > 0
                   }
            />
          </form>
        </div>
        {mustSelectWithdrawalAddressMessages.length > 0 &&
        <ul className="card-summary-submit-errors">
          {mustSelectWithdrawalAddressMessages}
        </ul>
        }
      </div>
    </>
  );
};
